var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "home"
  }, [_c('Header'), _c('div', {
    staticClass: "usercont content"
  }, [_c('NavMenu'), _c('div', {
    staticClass: "menucont success"
  }, [_c('div', {
    staticClass: "successcont"
  }, [_c('i', {
    staticClass: "iconfont icongouxuanxuanzhong"
  }), _c('h4', [_vm._v("售后申请提交成功")]), _c('p', [_vm._v("售后专员可能与您电话沟通，请保持手机畅通")]), _c('div', {
    staticClass: "progress",
    on: {
      "click": _vm.checkOrder
    }
  }, [_vm._v("查看进度")])]), _vm._m(0)])], 1), _c('BackTop'), _c('Footer', {
    attrs: {
      "isFixed": "true"
    }
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "warning"
  }, [_c('h3', [_vm._v("温馨提示")]), _c('p', [_vm._v("商品寄回地址将在审核通过后，在申请记录中查询")]), _c('p', [_vm._v("提交服务单后，售后专员可能与您电话沟通，请保持手机畅通")]), _c('p', [_vm._v("退货处理成功后退款金额将原路返回到您的支付账户中")])]);
}];
export { render, staticRenderFns };